import { defineStore } from 'pinia';
import { ref } from 'vue';
import api from '@/api';
export const useUserStore = defineStore('user', () => {
    const token = ref(localStorage.getItem('token') || '');
    const userInfo = ref(null);
    // 初始化时恢复用户信息
    const initUser = () => {
        const savedUserInfo = localStorage.getItem('userInfo');
        if (savedUserInfo) {
            try {
                userInfo.value = JSON.parse(savedUserInfo);
            }
            catch (error) {
                console.error('解析用户信息失败:', error);
                logout();
            }
        }
    };
    // 立即初始化
    initUser();
    // 登录
    const login = async (credentials) => {
        const { data } = await api.auth.userLogin(credentials);
        token.value = data.token;
        userInfo.value = data.user;
        localStorage.setItem('token', data.token);
        localStorage.setItem('userInfo', JSON.stringify(data.user));
        return data;
    };
    // 获取用户信息
    const getUserInfo = async () => {
        try {
            const { data } = await api.auth.getUserInfo();
            userInfo.value = data;
            localStorage.setItem('userInfo', JSON.stringify(data));
            return data;
        }
        catch (error) {
            logout();
            throw error;
        }
    };
    // 登出
    const logout = () => {
        token.value = '';
        userInfo.value = null;
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
    };
    // 检查是否已登录
    const isLoggedIn = () => {
        return !!token.value && !!userInfo.value;
    };
    return {
        token,
        userInfo,
        login,
        getUserInfo,
        logout,
        isLoggedIn
    };
});
